import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectRoleComponent } from './select-role/select-role.component';
import { ConfirmationPopupComponent } from './confirmation-popup/confirmation-popup.component';
import { ToastModule } from 'primeng/toast';
import {ButtonModule} from 'primeng/button';

@NgModule({
  declarations: [
    SelectRoleComponent,
    ConfirmationPopupComponent
  ],
  imports: [
    CommonModule,
    ToastModule,
    ButtonModule
  ],
  exports: [
    SelectRoleComponent,
    ConfirmationPopupComponent
  ]
})
export class SharedModule { }
